import { formattedDateTime } from "@sp-crm/core";
import { ClientTransferSubject, TransferRow } from "./transfer-types";

export interface TransferRecordField {
    label: string;
    value: string;
}

export const formatTransferDate = (value: string): string =>
    formattedDateTime("ll", value, "");

interface DateLabels {
    estimated: string;
    actual: string;
}

const dateLabels = (kind: ClientTransferSubject["kind"]): DateLabels => {
    switch (kind) {
        case "placement":
            return { estimated: "Est. move", actual: "Moved" };
        case "homeCareLead":
            return { estimated: "Est. start of care", actual: "Start of care" };
    }
    const exhaustiveCheck: never = kind;
    throw new Error(`Unhandled transfer kind ${String(exhaustiveCheck)}`);
};

const dateField = (label: string, date: string | null): TransferRecordField | null =>
    date ? { label, value: formatTransferDate(date) } : null;

const hoursPerWeekField = (hours: number | null): TransferRecordField | null =>
    hours === null ? null : { label: "Hours per week", value: String(hours) };

const kindFields = (row: TransferRow): (TransferRecordField | null)[] => {
    const kind = row.kind;
    switch (kind) {
        case "placement":
            return [];
        case "homeCareLead":
            return [
                dateField("End of care", row.clientEndDate),
                hoursPerWeekField(row.clientHoursPerWeek),
            ];
    }
    const exhaustiveCheck: never = kind;
    throw new Error(`Unhandled transfer kind ${String(exhaustiveCheck)}`);
};

export const transferRecordFields = (row: TransferRow): TransferRecordField[] => {
    const labels = dateLabels(row.kind);
    return [
        dateField(labels.estimated, row.clientEstimatedDate),
        dateField(labels.actual, row.clientActualDate),
        ...kindFields(row),
    ].filter((field): field is TransferRecordField => field !== null);
};
